"use client";

import { FAQAccordion } from "@/components/FAQAccordion";
import { PageBottomCta } from "@/components/PageBottomCta";
import { SectionRenderer } from "@/components/sections/SectionRenderer";
import { useLanguage } from "@/components/LanguageProvider";
import { pageHasCtaSection, withDarkCtaStyle } from "@/lib/cmsCta";
import type { PageSection } from "@/lib/api";
import type { FAQ } from "@/lib/types";

type Props = {
  sections: PageSection[];
  faqs: FAQ[];
  showApiFaqs: boolean;
};

export function AboutPageSections({ sections, faqs, showApiFaqs }: Props) {
  const { t, dir } = useLanguage();

  return (
    <div dir={dir}>
      {sections.map((section) => (
        <SectionRenderer
          key={section.id}
          section={withDarkCtaStyle(section)}
        />
      ))}
      {showApiFaqs && faqs.length > 0 ? (
        <div className="border-t border-slate-200/80 bg-gradient-to-b from-slate-50/50 to-white">
          <FAQAccordion
            heading={t("about.faq.heading")}
            subheading={t("about.faq.subheading")}
            faqs={faqs}
          />
        </div>
      ) : null}
      {!pageHasCtaSection(sections) ? (
        <PageBottomCta
          fallback={{
            heading: "home.cta.heading",
            subheading: "home.cta.subtitle",
            button: "home.cta.button",
          }}
        />
      ) : null}
    </div>
  );
}
